import React, { useEffect, useState } from 'react'
import { Box, Text, Heading } from '@chakra-ui/react'
import { isSuccessStatus } from 'utils/functions/validations'
import FormRegisterCompany from 'components/FormRegisterCompany/FormRegisterCompany'
import { useParams, useNavigate } from 'react-router-dom'
import { getCompany, getCategoryIva, getCategoryIIBB, getProvincias } from 'services/api'
import { ICompany, IFetchedGetCompany, IIibbCategory, IIvaCategory, IProvinciaCategory } from 'services/IApi.d'

export interface RegisterCompanyProps {
  cuit: string;
  codigoIIBB: string;
  isEditable: boolean;
  isLoaded: boolean;
  informationCompany: ICompany,
  categoryIva: IIvaCategory,
  categoryIibb: IIibbCategory,
  provinces: IProvinciaCategory,
}

const Company = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [initialData, setInitialData] = useState<RegisterCompanyProps>(null)

  useEffect(() => {
    const getData = async idCompany => {
      try {
        let responses = {}
        const [categoryIva, categoryIibb, provinces] = await Promise.all([getCategoryIva(), getCategoryIIBB(), getProvincias()])
        if (idCompany) {
          const { status, data }: IFetchedGetCompany = await getCompany(idCompany)
          if (!isSuccessStatus(status)) {
            navigate('/dashboard')
          }
          responses = { ...responses, informationCompany: data }
        }

        if (categoryIva.status === 200 && categoryIibb.status === 200 && provinces.status === 200) {
          responses = {
            ...responses,
            categoryIva: categoryIva.data,
            categoryIibb: categoryIibb.data,
            provinces: provinces.data,
          }
        }
        setIsLoaded(true)
        return responses
      } catch (error) {
        return error
      }
    }
    getData(id)
      .then(data => {
        setInitialData({ ...data, isEditable: !!id })
      })
  }, [])

  return (
    <Box>
      <Text textStyle='h3'>
        Sobre tu compañía
      </Text>
      <Text textStyle='h5'>
        Ingresá tu CUIT para completar la información de tu empresa.
      </Text>
      <FormRegisterCompany {...initialData} isLoaded={isLoaded} />
    </Box>
  )
}

export default Company
